import {DomainNameEnum} from '../../../../../../../provider/domain-config/domain-config-type';
import {ShortLocaleNameEnum} from '../../../../../../../provider/locale/locale-context-type';
import {LangKeyType} from '../../../../../../../provider/locale/translation/type';
import {YandexCompanyStatusEnum} from '../../../../../../../service/reivew-analysis/rating-dynamics/reviews-analytics-ratings-dynamic-type';

export const yandexActualizationStatusMarkPopoverTitleLangKey: Record<
    YandexCompanyStatusEnum | 'priorityPlacement',
    LangKeyType
> = {
    [YandexCompanyStatusEnum.Actualized]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__YANDEX_STATUS__POPOVER_TITLE__ACTUALIZED',
    [YandexCompanyStatusEnum.NotActualized]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__YANDEX_STATUS__POPOVER_TITLE__NOT_ACTUALIZED',
    [YandexCompanyStatusEnum.NeedActualize]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__YANDEX_STATUS__POPOVER_TITLE__NEED_ACTUALIZATION',
    priorityPlacement: 'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__YANDEX_STATUS__POPOVER_TITLE__PRIORITY_PLACEMENT',
};

export const yandexActualizationStatusMarkPopoverContentLangKey: Record<
    YandexCompanyStatusEnum | 'priorityPlacement',
    LangKeyType
> = {
    [YandexCompanyStatusEnum.Actualized]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__YANDEX_STATUS__POPOVER_CONTENT__ACTUALIZED',
    [YandexCompanyStatusEnum.NotActualized]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__YANDEX_STATUS__POPOVER_CONTENT__NOT_ACTUALIZED',
    [YandexCompanyStatusEnum.NeedActualize]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__YANDEX_STATUS__POPOVER_CONTENT__NEED_ACTUALIZATION',
    priorityPlacement: 'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__YANDEX_STATUS__POPOVER_CONTENT__PRIORITY_PLACEMENT',
};

export function getDocumentationLink(options: {
    localeName: ShortLocaleNameEnum;
    domainName: string;
    priorityPlacement: boolean;
}): string | null {
    const {localeName, domainName, priorityPlacement} = options;

    if (domainName === DomainNameEnum.brandWizard) {
        if (priorityPlacement) {
            return null;
        }

        return 'https://help.brandwizard.io/knowledge/how-to-get-and-keep-the-blue-checkmark-in-yandex';
    }

    if (localeName === ShortLocaleNameEnum.ru || localeName === ShortLocaleNameEnum.kk) {
        if (priorityPlacement) {
            return 'https://yandex.ru/support/business-priority/ru/benefits';
        }

        return 'https://yandex.ru/support/business-priority/manage/verified-owner.html';
    }

    if (priorityPlacement) {
        return null;
    }

    return 'https://roketdata.helpdeskeddy.com/en/knowledge_base/art/403/cat/38';
}
